function autoResize(textarea) {
  if (
    !textarea.offsetParent &&
    textarea.offsetWidth === 0 &&
    textarea.offsetHeight === 0
  )
    return;

  const minHeight = parseInt(textarea.dataset.autoResizeMinHeight, 10) || 0;
  textarea.style.overflow = 'hidden';
  textarea.style.height = 'auto';
  const newHeight = Math.max(textarea.scrollHeight, minHeight);
  textarea.style.height = newHeight + 'px';
}

function attach(textarea) {
  if (textarea.dataset.autoResizeAttached) return;
  textarea.dataset.autoResizeAttached = 'true';

  const computedHeight = parseInt(window.getComputedStyle(textarea).height, 10);
  if (computedHeight > 0) {
    textarea.dataset.autoResizeMinHeight = String(computedHeight);
  }

  autoResize(textarea);
  textarea.addEventListener('input', () => autoResize(textarea));
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('textarea').forEach(attach);
});

window.autosize = (elements) => {
  if (elements instanceof NodeList || Array.isArray(elements)) {
    elements.forEach(attach);
  } else if (elements instanceof HTMLElement) {
    attach(elements);
  }
};
